import { SiteAboutPanel } from '@jarvis/platform-ui';
import { SITE_SUPPORT_COPY } from '../../siteSupport/config';

export function SettingsAboutPage() {
  return <SiteAboutPanel productName={SITE_SUPPORT_COPY.productName} />;
}
